<template>
  <div>
    <div style="width: 20cm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div v-for="(item, index) in order" :key="index">
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td rowspan="3">
                <div :id="'qrCode' + item.billNo" align="center" />
              </td>
              <td colspan="3" style="font-weight: 700; font-size: 14px" align="center">发料单</td>
            </tr>
            <tr>
              <td>工单编号：{{ item.productionOrderNo }}</td>
              <td>派工单号：{{ item.billNo }}</td>
              <td>工单类型：{{ item.prodOrderTypeName }}</td>
            </tr>
            <tr>
              <td>物料编号：{{ item.materialNo }}</td>
              <td colspan="2">物料名称：{{ item.materialName }}</td>
            </tr>
            <tr>
              <td>工单数量：{{ item.quantity }}</td>
              <td>单位：{{ item.unitName }}</td>
              <td colspan="2">规格：</td>
            </tr>
            <tr>
              <td>生产中心：{{ item.workCenterName }}</td>
              <td>工艺路线：{{ item.routingName }}</td>
              <td colspan="2">合同号：{{ item.customerContractNo }}</td>
            </tr>
            <tr>
              <td colspan="2">开工时间：{{ item.planStartTime }}</td>
              <td colspan="2">完工时间：{{ item.planFinishTime }}</td>
            </tr>
            <tr>
              <td colspan="2">销售单号：{{ item.salesOrderNo }}</td>
              <td colspan="2">ERP单号：{{ item.erpSalesOrderNo }}</td>
            </tr>
            <tr>
              <td colspan="2">项目名称：{{ item.projectName }}</td>
              <td colspan="2">客户名称：{{ item.customerName }}</td>
            </tr>
          </table>
        </div>
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td>物料编号</td>
              <td>物料名称</td>
              <td class="ceil">需求数量</td>
              <td class="ceil">实发数量</td>
              <td class="ceil">单位</td>
            </tr>
            <tr v-for="i in item.bomList" :key="i.pkid">
              <td>{{ i.materialNo }}</td>
              <td>{{ i.materialName }}</td>
              <td class="ceil">{{ i.quantity }}</td>
              <td class="ceil">{{ i.ngQuantity }}</td>
              <td class="ceil">{{ i.unitName }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      order: [],
    };
  },

  mounted() {
    this.getDetail(this.$route.query.params);
    return;
    this.order = JSON.parse(this.$route.query.params);
    for (let item of this.order) {
      this.$nextTick(() => {
        document.getElementById("qrCode" + item.billNo).innerHTML = "";
        this.bindQRCode(item.billNo);
      });
    }
  },

  methods: {
    // 获取派工单明细(包含发料明细)
    getDetail(pkid) {
      this.$http.get("basic", `taskDispatchBills/${pkid}`).then((res) => {
        if (res.success) {
          console.log(res.data);
        }
      });
    },

    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 110,
        height: 110,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 20cm;
  border: 1px solid #111;
  font-size: 10px;
  margin: 10px auto;
  table {
    width: 100%;
    tr {
      td {
        border-bottom: 1px solid #111;
        border-right: 1px solid #111;
        padding: 10px 5px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
    .ceil {
      width: 80px;
      text-align: center;
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
